import React, { useRef } from "react";
import styles from '../styles/Home.module.scss';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "./CustomImage";
import Link from "next/link";
import LazyReveal from "./LazyReveal";

interface Props {
  sectionData: any
}

const settings = {
  dotsClass: styles.sliderDots,
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};


const HomePageServices: React.FC<Props> = ({ sectionData }: any) => {
  const sliderRef = useRef<Slider>(null);
  const { servicesTitle, serviceType } = sectionData
  return (
    <>
      <LazyReveal id="home-page-services" className="d-none d-sm-block">
        {
          serviceType.length > 0 && serviceType.map((singleService: any, index: number) => {
            const { serviceTitle, serviceDesc, offerings, bgColor, id, seeMoreUrl, imagePath, imageAltTag } = singleService
            return (
              <div className={styles.home_page_service_div} key={id} style={{ backgroundColor: bgColor }}>
                <Container>
                  {index % 2 === 0
                    ? <Row>
                      {index === 0 && <div className={styles.serviceHead}>
                        <h2 className="text-center">{servicesTitle}</h2>
                      </div>}
                      <Col xs={12} lg={6} sm={6}>
                        <div className={styles.service_content}>
                          <div className={styles.content}>
                            <h3>{serviceTitle}</h3>
                            <p>{serviceDesc}</p>
                          </div>
                          <div className={styles.offers}>
                            <h4>Offerings</h4>
                            <ul>
                              {
                                offerings.length > 0 && offerings.map((offer: string, ind: number) => <li key={ind}>{offer}</li>)
                              }
                            </ul>
                            <Link href={seeMoreUrl}><a className={styles.serviceAnchor}>See More</a></Link>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} lg={6} sm={6} className="text-center">
                        <div className={styles.service_img_slider}>
                          <CustomImage src={imagePath || `/images/home-page-service-${id}.svg`} alt={imageAltTag} width={375} height={424} />
                        </div>
                      </Col>
                    </Row>
                    : <Row>
                      <Col xs={12} lg={6} sm={6} className="text-center">
                        <div className={styles.service_img_slider}>
                          <CustomImage src={imagePath || `/images/home-page-service-${id}.svg`} alt={imageAltTag} width={375} height={424} />
                        </div>
                      </Col>
                      <Col xs={12} lg={6} sm={6}>
                        <div className={styles.service_content}>
                          <div className={styles.content}>
                            <h3>{serviceTitle}</h3>
                            <p>{serviceDesc}</p>
                          </div>
                          <div className={styles.offers}>
                            <h4>Offerings</h4>
                            <ul>
                              {
                                offerings.length > 0 && offerings.map((offer: string, ind: number) => <li key={ind}>{offer}</li>)
                              }
                            </ul>
                            <Link href={seeMoreUrl}><a className={styles.serviceAnchor}>See More</a></Link>
                          </div>
                        </div>
                      </Col>
                    </Row>}
                </Container>
              </div>
            )
          })
        }
        {/* </Slider> */}
      </LazyReveal>

      {/* mobile view */}
      <LazyReveal id="home-page-servicem" className="d-block d-sm-none">
        <Slider {...settings} ref={sliderRef} className={styles.slider}>
          {serviceType.length > 0 && serviceType.map((singleService: any, index: number) => {
            const { serviceTitle, serviceDesc, offerings, bgColor, id, seeMoreUrl, imagePath, imageAltTag } = singleService
            return (
              <Container key={index}>
                <Row>
                  <Col>
                    <div className={styles.home_page_service_div}>
                      <h2 className="text-center mb-5">{servicesTitle}</h2>
                      <div className={styles.service_img_slider}>
                        <CustomImage src={imagePath || `/images/home-page-service-${id}.svg`} alt={imageAltTag} width={220} height={248.75} />
                      </div>
                      <div className={styles.service_content}>
                        <div className={styles.content}>
                          <h2>{serviceTitle}</h2>
                          <p>{serviceDesc}</p>
                        </div>
                        <div className={styles.offers}>
                          <h3>Offerings</h3>
                          <ul>
                            {
                              offerings.length > 0 && offerings.map((offer: string, ind: number) => <li key={ind}>{offer}</li>)
                            }
                          </ul>
                          <Link href={seeMoreUrl}><a>See More</a></Link>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            )
          })
          }
        </Slider>
        <div className={styles.arrowsClass}>
          <div onClick={() => sliderRef?.current?.slickPrev()}>
            <CustomImage src='/new-images/left-arrow.svg' alt='Left Arrow' height={17} width={10} />
          </div>
          <div onClick={() => sliderRef?.current?.slickNext()}>
            <CustomImage src='/new-images/right-arrow.svg' alt='Right Arrow' height={17} width={10} />
          </div>
        </div>
      </LazyReveal>
    </>

  )
}

export default HomePageServices;